export default __webpack_public_path__ + "static/media/wh_4.cc66d80e.mp3";